import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, LockKeyholeIcon, MapPinIcon } from 'lucide-react';
import type { Opportunity } from '../../types/content';
interface OpportunityCardProps {
  opportunity: Opportunity;
}
export function OpportunityCard({
  opportunity
}: OpportunityCardProps) {
  return <article className="group relative flex flex-col gap-4 rounded-2xl border border-plum/10 bg-white p-6 transition-[border-color] duration-150 hover:border-copper/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-390" data-mp="2jmc1qr21mj0l">
      <div className="min-w-0" data-id="element-391" data-mp="2thvvb6t4x5m6">
        <div className="flex flex-wrap items-center gap-2 text-xs" data-id="element-392" data-mp="2yaf5dtsm5im8">
          <span className="font-semibold text-copper-deep" data-id="element-393" data-mp="2yb8g15up0s9n">{opportunity.seniority}</span>
          <span className="text-plum/40" aria-hidden="true" data-id="element-394" data-mp="32bipishp20t9">
            ·
          </span>
          <span className="text-plum/65" data-id="element-395" data-mp="37cg6j1qywot6">{opportunity.industry}</span>
          {opportunity.confidential && <span className="inline-flex items-center gap-1 rounded-full bg-aubergine px-2 py-0.5 text-[11px] font-medium text-porcelain" data-id="element-396" data-mp="3cahn9g0x8c1h">
              <LockKeyholeIcon className="h-3 w-3" aria-hidden="true" data-id="element-397" data-mp="17m13uzurvwgz" />
              Confidential
            </span>}
        </div>
        <h3 className="mt-2 text-xl font-semibold text-aubergine" data-id="element-398" data-mp="13kz4mj0uvkf0">
          <Link to={`/opportunities/${opportunity.slug}`} className="after:absolute after:inset-0 focus:outline-none" data-id="element-399" data-mp="ylmgzw25u9bd">
            {opportunity.title}
          </Link>
        </h3>
        <p className="mt-1 text-sm text-plum/70" data-id="element-400" data-mp="1r9qngjsk2qf4">{opportunity.confidential ? 'Confidential organization' : opportunity.organization}</p>
        <p className="mt-2 flex items-center gap-1.5 text-sm text-plum/60" data-id="element-401" data-mp="1mi0b68a25sl2">
          <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-402" data-mp="1hkgy3bp3jlup" />
          {opportunity.location}
        </p>
      </div>
      <ArrowRightIcon className="h-5 w-5 shrink-0 text-copper transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-403" data-mp="2f0eakcb1lmm9" />
    </article>;
}